/**
 * 암호가 약한 경우
 */
 export default class WeakPasswordError extends Error {}